class Validate {
  static patterns(pattern) {
    const VALIDATION_PATTERNS = {
      fullName: '^[^0-9_\n]{3,100}$',
      email: '^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,50})+$',
      phoneNumber: '^[+]{0,1}[0-9 -]{8,15}$',
      message: '^(.|\n){1,2000}$',
      bool: 'true',
      notBlank: /^\s*\S+.*/
    };
    return VALIDATION_PATTERNS[pattern] ? VALIDATION_PATTERNS[pattern] : '';
  }

  static validateData(pattern, testData) {
    let exp = new RegExp(Validate.patterns(pattern));
    return exp.test(testData);
  }

  static byType(type, testData) {
    return Validate.validateData(type, testData);
  }

  static email(email) {
    return Validate.validateData('email', email);
  }

  static bool(bool) {
    return bool;
  }

  static validateName(name) {
    return Validate.notBlank(name) && Validate.validateData('fullName', name);
  }

  static phoneNumber(number) {
    return Validate.validateData('phoneNumber', number);
  }

  static notBlank(value) {
    return (
      typeof value !== 'undefined' &&
      value !== null &&
      Validate.validateData('notBlank', value)
    );
  }
}

module.exports = {
  Validate
};



// WEBPACK FOOTER //
// ./common/validation/validate.js